import { inheritsLoose as _inheritsLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Route } from 'react-router-dom';

var NotFound = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NotFound, _React$Component);

  function NotFound() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NotFound.prototype;

  _proto.render = function render() {
    return React__default.createElement(Route, {
      render: function render(_ref) {
        var staticContext = _ref.staticContext;
        if (staticContext) staticContext.statusCode = 404;
        return NotFound.data;
      }
    });
  };

  return NotFound;
}(React__default.Component); // just for test purpose


NotFound.data = "The Page You Were Looking For Was Not Found";

export default NotFound;
//# sourceMappingURL=NotFoundComponent.esm.js.map
